/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import { useForm } from "react-hook-form";
import { Modal, ModalBody, ModalClose, ModalContent, ModalFooter, ModalHeader, ModalTitle } from "../../ui/Modal";
import Form from "../../ui/form/Form";
import FormGroup from "../../ui/form/FormGroup";
import NumberField from "../../ui/form/NumberField";
import FormError from "../../ui/form/FormError";
import Button from "../../ui/Button";
import ButtonGroup from "../../ui/ButtonGroup";
import T from "../../ui/Translation";

const CustomTipModal = ({ isOpen, onClose, onSubmit, currency, isPending, visibleError }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
  } = useForm({
    defaultValues: {
      custom_tip: "",
    },
  });

  const handleModalClose = () => {
    reset();
    onClose();
  };

  const handleFormSubmit = async (data) => {
    if (data.custom_tip === "") {
      setError("custom_tip", {
        type: "manual",
        message: "error_value_is_empty",
      });

      return;
    }

    await onSubmit(data.custom_tip);
  };

  return (
    <Modal isOpen={isOpen} onClose={handleModalClose}>
      <ModalContent>
        <ModalHeader>
          <ModalTitle>Custom tip</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <Form id="customTipForm">
            <FormGroup>
              <NumberField
                control={control}
                name="custom_tip"
                label="Please enter the amount you would like to tip"
                placeholder="e.x 10"
                prefix={currency}
                min="0"
                step="0.01"
              />
              {visibleError && <FormError>{visibleError}</FormError>}
              {errors.custom_tip && <FormError name="custom_tip">{errors.custom_tip.message}</FormError>}
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <ButtonGroup itemsWidth="half">
            <ModalClose>
              <Button variant="outline" title="Cancel" />
            </ModalClose>
            <Button
              variant="primary"
              title="confirm"
              form="customTipForm"
              onClick={handleSubmit(handleFormSubmit)}
              loading={isPending}
            />
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default CustomTipModal;
